import { Component, OnInit, OnDestroy } from '@angular/core';
import { PoiService, Poi } from '../poi/poi.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { TitleCasePipe } from '@angular/common';
import { MetaService } from '../meta.service';

@Component({
  selector: 'app-municipality',
  templateUrl: './municipality.component.html',
  styleUrls: ['./municipality.component.sass']
})
export class MunicipalityComponent implements OnInit, OnDestroy {
  private subscription = new Subscription();
  private municipalitySlug: string = "";
  municipality: string = "";
  description: string = "";
  private pois: Poi[] = [];

  constructor(
    private route: ActivatedRoute, 
    private router: Router,
    private titleCasePipe: TitleCasePipe,
    private poiService: PoiService,
    private metaService: MetaService) { }

  ngOnInit() {
    this.subscription.add(this.poiService.loadPois().subscribe(pois => {
      this.pois = pois;
      this.subscription.add(this.route.params.subscribe(params => {
        if (params["municipality"] && params["municipality"].length > 0) {
          // console.log(params);
          this.municipalitySlug = params["municipality"];
          this.refreshMunicipality();
        }
        else {
          this.router.navigate(['']);
        }
      }));
    }));
    
  }

  refreshMunicipality() {
    const municipalities = Array.from(new Set(this.pois.map(poi => poi.municipality)));
    const match = municipalities.find(muni => this.metaService.slugify(muni) === this.municipalitySlug);
    if(match) {
      this.municipality = this.titleCasePipe.transform(match);
      this.description = `Hier findest du die schönsten Badeplätze, besten Restaurants und tolle Ausflüge in der Gemeinde ${this.municipality}.`
      this.metaService.setTitle(`Top Badeplätze, Restaurants und Ausflüge in ${this.municipality} | Seeguide.at`);
      this.metaService.setTags(`${this.municipality}, Badeplätze, Restaurants, Ausflüge, Empfehlungen, Essen, Tipps, Hotels, Unterkunft, günstig, billig`, this.description);
    }
    else if (this.municipalitySlug !== this.municipalitySlug.toLowerCase()) {
      this.router.navigate(['gemeinde', this.municipalitySlug.toLowerCase()]);
    }
    else {
      this.router.navigate(['']);
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
